// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Slider_sliderWrapper__zVNwt"};